import useSymbol from '@/hooks/use-symbol';
import { useAccountStore } from '@/store/use-account-store';
import { useMarketStore } from '@/store/use-markets-store';
import { useOrdersStore } from '@/store/use-orders-store';
import { getIsStatusEval } from '@/features/vest-capital/utils/status';
import { formatNumber, parseDecimalToBigInt } from '@/utils/value-format';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useStore } from 'zustand';
import { getEstFillPrice } from '../../utils/math';
import { OrderFormSchema } from '../order-form';

export default function EstFillPrice() {
  const symbol = useSymbol();

  const form = useFormContext<OrderFormSchema>();
  const isBuy = form.watch('order.isBuy');
  const sizeStr = form.watch('order.size');
  const isEval = useAccountStore((state) =>
    getIsStatusEval(state.getCapitalStatus(state.address)),
  );

  const priceDecimals = useStore(
    useMarketStore(symbol),
    (state) => state.marketSpec.priceDecimals,
  );

  const estFillPrice = useStore(useMarketStore(symbol), (state) => {
    const { priceDecimals, sizeDecimals } = state.marketSpec;
    const estFillPrice = getEstFillPrice(
      isBuy,
      parseDecimalToBigInt(sizeStr, sizeDecimals),
      state.book,
      priceDecimals,
      isEval,
    );
    return estFillPrice?.decimal;
  });

  useEffect(() => {
    useOrdersStore.setState({
      creationFormEstimateFillPrice: estFillPrice
        ? Number(estFillPrice)
        : undefined,
    });
  }, [estFillPrice]);

  return estFillPrice
    ? formatNumber(estFillPrice, {
        digits: Number(priceDecimals),
      })
    : '—';
}
